import {
  type TClientSecurityDetailed,
  type TClientSecurityForm,
  type TClientSecurityUpdateDto,
  type TSecurity,
  type TSecurityApi,
  type TSecurityDetailed,
  type TSecurityDetailedApi
} from '@/components/App/Security/types/security.types';
import { keysToCamelCase, keysToSnakeCase } from '@/services/helpers';

export const securityMapperFromApi = (security: TSecurityApi): TSecurity => {
  const camelCased = keysToCamelCase(security);
  return {
    ...camelCased,
    firstName: camelCased.firstName || '',
    lastName: camelCased.lastName || '',
    middleName: camelCased.middleName || ''
  };
};

export const securityDetailedMapperFromApi = (
  security: TSecurityDetailedApi
): TSecurityDetailed => {
  const camelCased = keysToCamelCase(security);
  return {
    ...camelCased,
    clientsSecurity: camelCased.clientsSecurity.sort(
      (a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    ),
    firstName: camelCased.firstName || '',
    lastName: camelCased.lastName || '',
    middleName: camelCased.middleName || ''
  };
};

export const securityDetailedMapperToForm = (
  security: TClientSecurityDetailed
): TClientSecurityForm => {
  return {
    commentForUser: security.commentForUser || '',
    securityComment: security.securityComment || '',
    statusUuid: security.status.uuid || ''
  };
};

export const securityDetailedMapperToUpdateDto = (
  security: TClientSecurityForm
): TClientSecurityUpdateDto => {
  const snakeCased = keysToSnakeCase(security);
  return {
    comment_for_user: security.commentForUser || '',
    security_comment: snakeCased.security_comment,
    status_uuid: snakeCased.status_uuid
  };
};
